import { Injectable } from '@angular/core';

@Injectable()
export class NativeChannelService {

    callPhoneNumber(phoneNumber: string) {
        console.log('Calling number: ' + phoneNumber);
        this._postMessage(`tel://${phoneNumber}`);
    }

    setUserToken(token: string) {
        console.log('Setting token: ' + token);
        this._postMessage(`setToken:${token}`);
    }

    openLink(url: string) {
        this._postMessage(url);
    }

    logoff() {
        console.log('Logging user off');
        this._postMessage('logoff');
    }

    private _postMessage(message: string): boolean {
        try {
            let w = (<any>window);

            // ios
            if (w.webkit) {
                w.webkit.messageHandlers.callbackHandler.postMessage(message);
                return true;
            }

            // android
            if (w.Android) {
                w.Android.postMessage(message);
                return true;
            }

        } catch (err) {
            console.log('error');
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/native-channel.service.ts